<template>
	<div :style="{backgroundColor:layout?.pageBackground?.color}">
		<section class="innovation-section" v-if="layout">
			<div class="container">
				<div class="row">
					<div class="block-title-w">
						<h2 class="block-title text-left" :style="{
							color: layout.box1?.heading?.color,
							backgroundColor: layout.box1?.heading?.backgroundColor,
							fontSize: layout.box1?.heading?.fontSize + 'px',
							fontFamily: layout.box1?.heading?.fontFamily,
							fontWeight: layout.box1?.heading?.bold ? 'bold' : 'normal'
						}">{{ layout.box1?.heading?.text }}</h2>
					</div>
					<div class="flex align-center design-content-block">
						<!-- Left Image -->
						<div class="left-image">
							<img :src="layout.box1?.image?.preview || 'https://picsum.photos/2000/3000/'"
								alt="Design Graphic" class="img-responsive img-rounded" />
						</div>

						<!-- Right Text Content -->
						<div class="right-content">
							<h3 class="design-title" :style="{
								color: layout.box2?.heading?.color,
								backgroundColor: layout.box2?.heading?.backgroundColor,
								fontSize: layout.box2?.heading?.fontSize + 'px',
								fontFamily: layout.box2?.heading?.fontFamily,
								fontWeight: layout.box2?.heading?.bold ? 'bold' : 'normal'
							}">
								{{ layout.box2?.heading?.text }}
							</h3>
							<p :style="{
								color: layout.box2?.messageContent?.color,
								backgroundColor: layout.box2?.messageContent?.backgroundColor,
								fontSize: layout.box2?.messageContent?.fontSize + 'px',
								fontFamily: layout.box2?.messageContent?.fontFamily,
								fontWeight: layout.box2?.messageContent?.bold ? 'bold' : 'normal'
							}">
								{{ layout.box2?.messageContent?.text }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>


		<section class="what-info-section" v-if="layout">
			<div class="container">
				<div class="row">
					<div class="flex vestiGO-info-section">
						<!-- Left Card -->
						<div class="info-card left-card">
							<h3 class="info-title" :style="{
								color: layout.box3?.heading?.color,
								backgroundColor: layout.box3?.heading?.backgroundColor,
								fontSize: layout.box3?.heading?.fontSize + 'px',
								fontFamily: layout.box3?.heading?.fontFamily,
								fontWeight: layout.box3?.heading?.bold ? 'bold' : 'normal'
							}">{{ layout.box3?.heading?.text }}</h3>
							<p class="info-subtitle" :style="{
								color: layout.box3?.subheading?.color,
								backgroundColor: layout.box3?.subheading?.backgroundColor,
								fontSize: layout.box3?.subheading?.fontSize + 'px',
								fontFamily: layout.box3?.subheading?.fontFamily,
								fontWeight: layout.box3?.subheading?.bold ? 'bold' : 'normal'
							}">{{ layout.box3?.subheading?.text }}</p>
							<p class="info-description" :style="{
								color: layout.box3?.messageContent?.color,
								backgroundColor: layout.box3?.messageContent?.backgroundColor,
								fontSize: layout.box3?.messageContent?.fontSize + 'px',
								fontFamily: layout.box3?.messageContent?.fontFamily,
								fontWeight: layout.box3?.messageContent?.bold ? 'bold' : 'normal'
							}">{{ layout.box3?.messageContent?.text }}
							</p>
						</div>

						<!-- Right Card -->
						<div class="info-card right-card text-center">
							<p class="quote-text" :style="{
								color: layout.box5?.textWithLink?.color,
								backgroundColor: layout.box5?.textWithLink?.backgroundColor,
								fontSize: layout.box5?.textWithLink?.fontSize + 'px',
								fontFamily: layout.box5?.textWithLink?.fontFamily,
								fontWeight: layout.box5?.textWithLink?.bold ? 'bold' : 'normal'
							}" v-if="layout.box5?.textWithLink?.text" v-html="processDesignLink(layout.box5.textWithLink.text)"></p>
						</div>
					</div>

				</div>
			</div>
		</section>

		<section class=" image-grid-section" v-if="layout">
			<div class="container">
				<div class="row">
					<h3 class="info-title" :style="{
						color: layout.box4?.heading?.color,
						backgroundColor: layout.box4?.heading?.backgroundColor,
						fontSize: layout.box4?.heading?.fontSize + 'px',
						fontFamily: layout.box4?.heading?.fontFamily,
						fontWeight: layout.box4?.heading?.bold ? 'bold' : 'normal',
						marginBottom: '20px'
					}">{{ layout.box4?.heading?.text }}</h3>
					<div class="single-img">
						<img :src="layout.box4?.image?.preview || 'https://picsum.photos/2000/3000/'"
							alt="Design Graphic" class="img-responsive img-rounded" />
					</div>
				</div>
			</div>

		</section>
	</div>
</template>

<script>
export default {
	name: "PageLayoutOne",
	props: {
		layout: Object
	},

	methods: {
		processDesignLink(content) {
			if (!content || !this.layout?.box5?.textWithLink?.linkText) return content;

			const linkText = this.layout.box5.textWithLink.linkText;
			let url = this.layout.box5.textWithLink.linkSuffix || '/design-quote';
			
			// If the URL doesn't start with http or /, make it absolute from root
			if (!url.startsWith('http://') && !url.startsWith('https://')) {
				// If it doesn't start with / either, make it absolute from root
				if (!url.startsWith('/')) {
					url = '/' + url;
				}
				// Now url is either already starting with / or we made it start with /
			}
			
			const color = this.layout.box5.textWithLink.linkColor || '#007bff';

			// Create case-insensitive regex to find the link text
			const regex = new RegExp(`\\b${linkText}\\b`, 'gi');
			return content.replace(regex, `<a href="${url}" style="color: ${color}; text-decoration: none; border-bottom: 2px solid ${color}; padding-bottom: 1px;">${linkText}</a>`);
		},
	}
}


</script>

<style>
.single-img img {
    width: 100%;
    height: 100%;
    max-height: 600px;
    aspect-ratio: 1 / 0.73;
    -o-object-fit: cover;
    object-fit: contain!important;
    border-radius: 16px;
}
.design-content-block{
	align-items: flex-start;
}
</style>